export const NAV = {
  dashboard: 'nav-dashboard',
  sirucRecords: 'nav-siruc-records',
  sirucInspections: 'nav-siruc-inspections',
  bitacoraVisitas: 'nav-bitacora-visitas',
  bitacoraEmbarque: 'nav-bitacora-embarque',
  bitacoraRecibo: 'nav-bitacora-recibo',
  bitacoraSellosColocados: 'nav-bitacora-sellos-colocados',
  bitacoraSellosRotos: 'nav-bitacora-sellos-rotos',
  recorridos: 'nav-recorridos',
  users: 'nav-users',
  logout: 'nav-logout',
};
